module.exports = __webpack_public_path__ + "static/img/news40_1.8af32c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/technology/news40_1.png
// module id = rg3S
// module chunks = 0